import { useMutation, useQueryClient } from "@tanstack/vue-query";

import { useServices } from "@/configuration/plugins/app/app-provider.configuration";
import { InternalMutationKeys } from "@/data/api/kili/internal/internal-query-keys";
import { SitesQueryKeys } from "@/data/api/kili/sites/sites-query-keys";
import { mapSubprogramsDto } from "@/data/api/v4b/program/subprogram.mapping";
import { V4HSiteId } from "@/data/common/ids";
import { ProgramColorName } from "@/domains/v4b/program/program.types";
import { SubprogramsByApplianceCategory } from "@/domains/v4b/program/subprogram.types";

export type TCreateProgramCommand = {
  name: string;
  siteId: V4HSiteId;
  subPrograms: SubprogramsByApplianceCategory;
  frontDisplayColor?: ProgramColorName;
};

export function useCreateSiteProgramMutation() {
  const v4bClientSdk = useServices().v4b.clientSdk;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: InternalMutationKeys.createSiteProgram(),
    mutationFn: async (body: TCreateProgramCommand) => {
      const result = await v4bClientSdk.siteProgram.createProgram({
        ...body,
        subprograms: mapSubprogramsDto(body.subPrograms),
      });

      await queryClient.removeQueries({
        queryKey: SitesQueryKeys.programs(body.siteId),
      });

      return result;
    },
  });
}
